import Model from './Model'
import { _pageOptions, _pagination } from './defaults'
import type {
  ModelConfig,
  Pagination,
  PageOptions,
  WhereQuery,
  FilterQuery,
  BaseModel
} from './interfaces'

export {
  _pageOptions,
  _pagination,
  ModelConfig,
  Pagination,
  PageOptions,
  WhereQuery,
  FilterQuery,
  BaseModel
}

export default Model
